import { getCancelPolicyDetails } from "@tm/insurance/api";
import { getPartnerOnClientSide } from "@tm/insurance/utils";
import type { ParsedUrlQuery } from "querystring";
import { useCallback, useMemo, useState } from "react";
import type { CancelPolicyApiResponse } from "../types";
import { normalizeCancelPolicy } from "../utils/normalize";

interface UseCancellationDataOptions {
  data: CancelPolicyApiResponse;
  routerQuery: ParsedUrlQuery;
}

export function useCancellationData({
  data,
  routerQuery,
}: UseCancellationDataOptions) {
  const [rawData, setRawData] = useState(data);
  const normalizedData = useMemo(
    () => normalizeCancelPolicy(rawData),
    [rawData]
  );

  const refreshCancellationDetails = useCallback(async () => {
    const partner = getPartnerOnClientSide();
    const updatedData = await getCancelPolicyDetails({
      partner,
      bookingId: normalizedData.bookingId,
      query: routerQuery,
    });
    setRawData(updatedData);
  }, [normalizedData.bookingId, routerQuery]);

  return {
    normalizedData,
    setCancellationData: setRawData,
    refreshCancellationDetails,
  };
}
